import { createEnv } from '@t3-oss/env-nextjs';
import { z } from 'zod';

export const env = createEnv({
  server: {
    NODE_ENV: z.enum(['development', 'production']),

    //openai
    OPENAI_API_KEY: z.string(),
    OPENAI_API_KEY_SUM: z.string(),

    //database planetscale
    BOTSCRIBE_DATABASE_URL: z.string(),

    //mailgun
    MAILGUN_API_KEY: z.string(),
    MAILGUN_DOMAIN: z.string(),

    //liveblocks
    LIVEBLOCKS_API_KEY: z.string(),
    LIVEBLOCKS_WEBHOOK_SECRET: z.string(),

    //unstructured
    UNSTRUCTURED_API_KEY: z.string(),

    //anthropic
    ANTHROPIC_API_KEY: z.string(),

    //resend
    RESEND_API_KEY: z.string(),

    //slack
    SLACK_WEBHOOK_BASE_URL: z.string(),
    SLACK_WEBHOOK_COMPANY_SIGNUP: z.string(),
    SLACK_WEBHOOK_FEEDBACK: z.string(),
    SLACK_WEBHOOK_TEAM: z.string(),

    //churnkey
    CHURNKEY_API_KEY: z.string(),

    //convertapi
    CONVERTAPI_API_SECRET: z.string(),
    CONVERTAPI_API_KEY: z.string(),

    //aws
    AWS_ACCESS_KEY_ID: z.string(),
    AWS_SECRET_ACCESS_KEY: z.string(),
    AWS_REGION: z.string(),

    //jina
    JINA_API_KEY: z.string(),

    //stripe
    STRIPE_SECRET_KEY_LIVE: z.string(),
    STRIPE_SECRET_KEY: z.string(),
    US_STRIPE_SECRET_KEY_LIVE: z.string(),
    US_STRIPE_SECRET_KEY: z.string(),
    STRIPE_US_WEBHOOK_SECRET: z.string(),
  },
  client: {
    //site condig
    NEXT_PUBLIC_BASE_URL: z.string(),
    NEXT_PUBLIC_SITE_URL: z.string(),
    NEXT_PUBLIC_VERCEL_URL: z.string().optional(),
    NEXT_PUBLIC_UNRIDDLE_API_URL: z.string(),

    //gcp
    NEXT_PUBLIC_FIREBASE_PUBLIC_API_KEY: z.string(),
    NEXT_PUBLIC_PROJECT_ID: z.string(),

    NEXT_PUBLIC_CLIENT_EMAIL: z.string(),
    NEXT_PUBLIC_PRIVATE_KEY: z.string(),
    NEXT_PUBLIC_BUCKET_NAME: z.string(),
    NEXT_PUBLIC_SPREADSHEET_ID: z.string(),
    NEXT_PUBLIC_SHEET_ID: z.string(),

    //amplitude
    NEXT_PUBLIC_AMPLITUDE_API_KEY: z.string(),

    //pinecone
    NEXT_PUBLIC_PINECONE_INDEX: z.string(),

    //stripe
    NEXT_PUBLIC_US_STRIPE_PUBLISHABLE_KEY: z.string(),
    NEXT_PUBLIC_US_STRIPE_PRO_MONTHLY: z.string(),
    NEXT_PUBLIC_US_STRIPE_PRO_YEARLY: z.string(),
    NEXT_PUBLIC_US_STRIPE_PREMIUM_MONTHLY: z.string(),
    NEXT_PUBLIC_US_STRIPE_PREMIUM_YEARLY: z.string(),
    NEXT_PUBLIC_US_STRIPE_TEAM_MONTHLY: z.string(),
    NEXT_PUBLIC_US_STRIPE_TEAM_YEARLY: z.string(),
    NEXT_PUBLIC_US_STRIPE_FRIEND: z.string(),

    //convertkit
    NEXT_PUBLIC_CONVERTKIT_API_KEY: z.string(),
    NEXT_PUBLIC_CONVERTKIT_SECRET_KEY: z.string(),
    NEXT_PUBLIC_CONVERTKIT_FORM_ID: z.string(),

    //ga
    NEXT_PUBLIC_MEASUREMENT_ID: z.string().optional(),
  },

  // For Next.js >= 13.4.4, you only need to destructure client variables:
  experimental__runtimeEnv: {
    NEXT_PUBLIC_BASE_URL: process.env.NEXT_PUBLIC_BASE_URL,
    NEXT_PUBLIC_SITE_URL: process.env.NEXT_PUBLIC_SITE_URL,
    NEXT_PUBLIC_VERCEL_URL: process.env.NEXT_PUBLIC_VERCEL_URL,
    NEXT_PUBLIC_UNRIDDLE_API_URL: process.env.NEXT_PUBLIC_UNRIDDLE_API_URL,
    NEXT_PUBLIC_FIREBASE_PUBLIC_API_KEY:
      process.env.NEXT_PUBLIC_FIREBASE_PUBLIC_API_KEY,
    NEXT_PUBLIC_PROJECT_ID: process.env.NEXT_PUBLIC_PROJECT_ID,
    NEXT_PUBLIC_CLIENT_EMAIL: process.env.NEXT_PUBLIC_CLIENT_EMAIL,
    NEXT_PUBLIC_PRIVATE_KEY: process.env.NEXT_PUBLIC_PRIVATE_KEY,
    NEXT_PUBLIC_BUCKET_NAME: process.env.NEXT_PUBLIC_BUCKET_NAME,
    NEXT_PUBLIC_SPREADSHEET_ID: process.env.NEXT_PUBLIC_SPREADSHEET_ID,
    NEXT_PUBLIC_SHEET_ID: process.env.NEXT_PUBLIC_SHEET_ID,
    NEXT_PUBLIC_AMPLITUDE_API_KEY: process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY,
    NEXT_PUBLIC_PINECONE_INDEX: process.env.NEXT_PUBLIC_PINECONE_INDEX,
    NEXT_PUBLIC_CONVERTKIT_API_KEY: process.env.NEXT_PUBLIC_CONVERTKIT_API_KEY,
    NEXT_PUBLIC_CONVERTKIT_SECRET_KEY:
      process.env.NEXT_PUBLIC_CONVERTKIT_SECRET_KEY,
    NEXT_PUBLIC_CONVERTKIT_FORM_ID: process.env.NEXT_PUBLIC_CONVERTKIT_FORM_ID,
    NEXT_PUBLIC_MEASUREMENT_ID: process.env.NEXT_PUBLIC_MEASUREMENT_ID,
    NEXT_PUBLIC_US_STRIPE_PUBLISHABLE_KEY:
      process.env.NEXT_PUBLIC_US_STRIPE_PUBLISHABLE_KEY,
    NEXT_PUBLIC_US_STRIPE_PRO_MONTHLY:
      process.env.NEXT_PUBLIC_US_STRIPE_PRO_MONTHLY,
    NEXT_PUBLIC_US_STRIPE_PRO_YEARLY:
      process.env.NEXT_PUBLIC_US_STRIPE_PRO_YEARLY,
    NEXT_PUBLIC_US_STRIPE_PREMIUM_MONTHLY:
      process.env.NEXT_PUBLIC_US_STRIPE_PREMIUM_MONTHLY,
    NEXT_PUBLIC_US_STRIPE_PREMIUM_YEARLY:
      process.env.NEXT_PUBLIC_US_STRIPE_PREMIUM_YEARLY,
    NEXT_PUBLIC_US_STRIPE_TEAM_MONTHLY:
      process.env.NEXT_PUBLIC_US_STRIPE_TEAM_MONTHLY,
    NEXT_PUBLIC_US_STRIPE_TEAM_YEARLY:
      process.env.NEXT_PUBLIC_US_STRIPE_TEAM_YEARLY,
    NEXT_PUBLIC_US_STRIPE_FRIEND: process.env.NEXT_PUBLIC_US_STRIPE_FRIEND,
  },
});
